import { ESite_HeaderBidderWinnerModel } from '~/src/dash/api/console-api';

export interface IWinnerModel {
  key: ESite_HeaderBidderWinnerModel;
  text: string;
}

export const winnerModels: IWinnerModel[] = [
  { key: ESite_HeaderBidderWinnerModel.Site_HB_WINNER_MODEL_UNKNOWN, text: 'Unknown' },
  {
    key: ESite_HeaderBidderWinnerModel.Site_HB_WINNER_MODEL_PRICE_PER_SECOND,
    text: 'Price per second',
  },
  { key: ESite_HeaderBidderWinnerModel.Site_HB_WINNER_MODEL_PRICE, text: 'Price' },
  { key: ESite_HeaderBidderWinnerModel.Site_HB_WINNER_MODEL_BOTH, text: 'Both' },
];
